import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/store';

const SignInPage = () => import('../pages/SignInPage');
const SignUpPage = () => import('../pages/SignUpPage');
const RestorePasswordPage = () => import('../pages/RestorePasswordPage');
const EventsPage = () => import('../pages/EventsPage');
const PeoplePage = () => import('../pages/PeoplePage');
const TransactionsPage = () => import('../pages/TransactionsPage');
const MySharePage = () => import('../pages/MySharePage');
const DebtsPage = () => import('../pages/DebtsPage');
const CheckUserPage = () => import('../pages/CheckUserPage');
const FaqPage = () => import('../pages/FaqPage');
const Page404 = () => import('../pages/Page404');
const WellKnown = () => import('../components/WellKnown/WellKnown');

Vue.use(VueRouter);

const checkIfUserHasNoInitials = () => {
  if (store.state.user.user.user && !store.state.user.user.full_name) {
    // console.log(store.getters.isAuthenticated, !store.state.user.user.full_name);
    return true;
  }
  return false;
};

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/');
};

const ifAuthenticated = (to, from, next) => {
  const userHasNoName = checkIfUserHasNoInitials();
  if (to.path === '/' && store.getters.isAuthenticated && userHasNoName) {
    next();
    return;
  }
  if (userHasNoName && store.getters.isAuthenticated) {
    next('/checkuser');
  } else if (store.getters.isAuthenticated) {
    next();
  } else next('/signin');
};

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      exact: true,
      redirect: '/events',
    },
    {
      path: '/signin',
      name: 'SignInPage',
      component: SignInPage,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/signup',
      name: 'SignUpPage',
      component: SignUpPage,
    },
    {
      path: '/checkuser',
      name: 'CheckUserPage',
      component: CheckUserPage,
    },
    {
      path: '/restore_password',
      name: 'RestorePasswordPage',
      component: RestorePasswordPage,
    },
    {
      path: '/events/:id(\\d+)?/',
      component: EventsPage,
      props: true,
      children: [
        {
          path: 'transactions',
          alias: '',
          name: 'TransactionsPage',
          component: TransactionsPage,

        },
        {
          path: 'my-share',
          name: 'MySharePage',
          component: MySharePage,
        },
        {
          path: 'debts',
          name: 'DebtsPage',
          component: DebtsPage,
        },
      ],
      beforeEnter: ifAuthenticated,
      beforeRouteUpdate: ifAuthenticated,
    },
    {
      path: '/people/:uid?',
      props: true,
      name: 'PeoplePage',
      component: PeoplePage,
      beforeEnter: ifAuthenticated,
      beforeRouteUpdate: ifAuthenticated,
    },
    {
      path: '/faq',
      name: 'FaqPage',
      component: FaqPage,
      beforeEnter: ifAuthenticated,
      beforeRouteUpdate: ifAuthenticated,
    },
    {
      path: '/.well-known/apple-app-site-association',
      component: WellKnown,
      props: {
        file: '../.well-known/apple-app-site-association',
      },
    },
    {
      path: '*',
      name: 'Page 404',
      component: Page404,
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.state.auth.error = '';
  next();
});

router.afterEach((to) => {
  let subTitle = to.path.split('/')[1];
  if (subTitle) {
    subTitle = subTitle[0].toUpperCase() + subTitle.slice(1);
    if (subTitle === 'Restore_password') subTitle = 'Restore password';
    document.title = `Repay - ${subTitle}`;
    return;
  }
  document.title = 'Repay';
});

export default router;
